export default function () {
  return [
    { key: 'subject' },{ key: 'mailEvent',label:'event' },
    { key: 'orgId', type: 'org', selectProps: { clearable: true, multiple: false } },
    { key: 'branchId', label: "businessUnit", type: 'bu', selectProps: { clearable: true, multiple: false } }
  ]
}
